type Step = {
  num: string;
  title: string;
  body: string;
};

const STEPS: Step[] = [
  {
    num: "01",
    title: "Book an intro call",
    body: "Quick 30-minute call to talk through what you're building, what's on the roadmap, and what kind of design help you need. No pressure, no pitch — just a conversation to see if we're a fit.",
  },
  {
    num: "02",
    title: "Onboarding",
    body: "We get plugged into your Slack, your Linear or Notion board, and your design system if you have one. By the end of week one we know your product, your tone, and how your team likes to work.",
  },
  {
    num: "03",
    title: "Unlimited Design",
    body: "Send work as you need it. One or two tasks active at a time, the rest sit in your queue. Unlimited revisions until it's right. Pause or cancel any month — no penalty.",
  },
];

export function HowItWorks() {
  return (
    <section className="sub-steps" aria-labelledby="s3-title">
      <div className="sub-steps-grid">
        <div className="sub-steps-inner">
          <h2 id="s3-title" className="sub-steps-heading" data-reveal>
            How it works
          </h2>
          <ol className="sub-steps-list">
            {STEPS.map((step) => (
              <li key={step.num} className="sub-steps-item" data-reveal>
                <span className="sub-steps-num">{step.num}</span>
                <h3 className="sub-steps-title">{step.title}</h3>
                <p className="sub-steps-body">{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
